module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Francis-Hanging-Salmon-Web-1280.1613e311.jpg";